import { axios } from '@/utils/request'

export function GetInfo() {
    return axios({
        url: '/api/pc/getInfo',
        method: 'get'
    })
}

export function GetBanner(data) {
    return axios({
        url: '/api/pc/getAll/'+ data,
        method: 'get'
    })
}


export function GetFeature(data) {
    return axios({
        url: '/api/pc/getFeature/' + data,
        method: 'get'
    })
}

export function GetNews(data) {
    return axios({
        url: '/api/pc/getNews/' + data,
        method: 'get'
    })
}

export function GetTime(data) {
    return axios({
        url: '/api/pc/getTime/' + data,
        method: 'get'
    })
}

export function GetIntro(data) {
    return axios({
        url: '/api/pc/getIntro/' + data,
        method: 'get'
    })
}

export function GetPageNews(data) {
    return axios({
        url: '/api/pc/getPageNews',
        method: 'get',
        params:data
    })
}

export function GetNewsDetail(id) {
    return axios({
        url:`/api/competitionNews/${id}`,
        method: 'get'
    })
}

export function GetPlatform(data) {
    return axios({
        url: '/api/pc/getPlatform/' + data,
        method: 'get'
    })
}

export function GetFiles(data) {
    return axios({
        url: '/api/pc/getFiles/' + data,
        method: 'get'
    })
}

export function sign(data) {
    return axios({
        url: '/api/login',
        method: 'post',
        data
    })
}



export function getUserInfo() {
    return axios({
        url: '/api/userInfo',
        method: 'get',
    })
}



export function getThreeInfo(data) {
    return axios({
        url: 'http://c5yun.chinajxedu.com/api_get_user_info.html',
        method: 'get',
        params:{
            data_string:`{"appid":"22051801","appkey":"8ea76752ab47b55b29cde380390bdd66","code":"${data}"}`
        }
    })
}



export function threelogin(data) {
    return axios({
        url: '/api/registerLogin',
        method: 'post',
        data
    })
}

export function getcaptcha(data) {
    return axios({
        url: '/api/captcha',
        method: 'post',
        data
    })
}


export function getApplyInfo(data) {
    return axios({
        url: '/api/aseanApply/mine',
        method: 'get',
        params:data
    })
}

export function toApply(data) {
    return axios({
        url: '/api/aseanApply',
        method: 'post',
        data
    })
}

export function editApplyInfo(data) {
    return axios({
        url: '/api/aseanApply',
        method: 'put',
        data
    })
}

export function getSchoolList(data) {
    return axios({
        url: '/api/aseanSchool',
        method: 'get',
        params:data
    })
}

export function getTeamList(applyId) {
    return axios({
        url: '/api/aseanTeam/byApply',
        method: 'get',
        params:{
            applyId
        }
    })
}

export function editTeam(data) {
    return axios({
        url: '/api/aseanTeam',
        method: 'put',
        data
    })
}

export function addTeam(data) {
    return axios({
        url: '/api/aseanTeam',
        method: 'post',
        data
    })
}



export function aseanApplyFile(data) {
    return axios({
        url: '/api/aseanApplyFile',
        method: 'post',
        data
    })
}


export function editApplyFile(data) {
    return axios({
        url: '/api/aseanApplyFile',
        method: 'put',
        data
    })
}

export function deleteApplyFile(id) {
    return axios({
        url: '/api/aseanApplyFile/'+id,
        method: 'delete'
    })
}

// 新增作品
export function addworks(data) {
    return axios({
        url: '/api/aseanWorks',
        method: 'post',
        data
    })
}

export function editworks(data) {
    return axios({
        url: '/api/aseanWorks',
        method: 'put',
        data
    })
}


export function delworks(id) {
    return axios({
        url: '/api/aseanWorks/'+id,
        method: 'delete',
    })
}


export function getCertificateByTeamId(data) {
    return axios({
        url: '/api/getCertificateByTeamId',
        method: 'get',
        params:data
    })
}



export function getCertificateBySchool(data) {
    return axios({
        url: '/api/getCertificateBySchool',
        method: 'get',
        params:data
    })
}


export function getCertificateByName(data) {
    return axios({
        url: '/api/getCertificateByName',
        method: 'get',
        params:data
    })
}


export function schoolCheck(data) {
    return axios({
        url: '/api/competitionTeamNew/schoolCheck',
        method: 'get',
        params:data
    })
}


export function getCompetitionWay() {
    return axios({
        url: '/api/competitionWay',
        method: 'get'
    })
}